import React from 'react';
import { Grid } from '@mui/material';
import { SEARCH_FORM_COMPONENT_TEST_ID } from 'testidConstants';
import SearchForm from 'components/search-form';

const Search = () => {

  return (
    <Grid container justifyContent="center" data-testid={SEARCH_FORM_COMPONENT_TEST_ID}>
      <SearchForm />
    </Grid>
  );
};

export default Search;
